import { render, staticRenderFns } from "./ActionsTratamientos.vue?vue&type=template&id=2efdadfa"
import script from "./ActionsTratamientos.vue?vue&type=script&lang=js"
export * from "./ActionsTratamientos.vue?vue&type=script&lang=js"
import style0 from "./ActionsTratamientos.vue?vue&type=style&index=0&id=2efdadfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports